module.exports = __webpack_public_path__ + "img/Andre-forbrugerprodukter.19c2a8af.jpg";